<template>
    <figure
        class="flex w-full max-w-xl justify-between gap-3 md:gap-4 xl:mx-auto xl:max-w-3xl"
    >
        <!-- Start of "Rubrika & Naslov" -->
        <template v-if="step == 1">
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green"
                >
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Rubrika & Naslov</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        2
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Podatki nepremičnine</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        3
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Slike, videji, ...</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        4
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Objavi oglas</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Rubrika & Naslov" -->

        <!-- Start of "Podatki nepremičnine" -->
        <template v-if="step == 2 || step == 3">
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Rubrika & Naslov</label
                    >
                </div>
            </div>
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green-25"
                >
                    <template v-if="step === 2">
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                        <div class="h-[6px] w-full bg-green-25"></div>
                    </template>
                    <template v-if="step === 3">
                        <div class="h-[6px] w-full bg-green"></div>
                        <div
                            class="h-[6px] w-full rounded-r-full bg-green"
                        ></div>
                    </template>
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        2
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Podatki nepremičnine</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        3
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Slike, videji, ...</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        4
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Objavi oglas</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Podatki nepremičnine" -->

        <!-- Start of "Slike, videji, ..." -->
        <template v-if="step == 4">
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Rubrika & naslovi</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        2
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Podatki nepremičnine</label
                    >
                </div>
            </div>
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green-25"
                >
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        3
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Slike, videji, ...</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green-25"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green-25 text-[8px] text-white"
                    >
                        4
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green-25 lg:flex"
                        >Objavi oglasa</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Slike, videji, ..." -->

        <!-- Start of "Predogled oglasa" -->
        <template v-if="(step == 5)">
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        1
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Rubrika & Naslov</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        2
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Podatki nepremičnine</label
                    >
                </div>
            </div>
            <div
                class="flex w-full flex-col items-center gap-[10px] max-md:max-w-[54px]"
            >
                <div class="h-[6px] w-full rounded-full bg-green"></div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        3
                    </div>
                    <label
                        class="hidden text-small-text-medium text-green lg:flex"
                        >Slike, videji, ...</label
                    >
                </div>
            </div>
            <div class="flex w-full flex-col items-center gap-[10px]">
                <div
                    class="flex h-[6px] w-full overflow-hidden rounded-full bg-green-25"
                >
                </div>
                <div class="flex gap-2">
                    <div
                        class="flex h-[12px] w-[12px] items-center justify-center rounded-full bg-green text-[8px] text-white"
                    >
                        4
                    </div>
                    <label class="text-small-text-medium text-green"
                        >Objavi oglasa</label
                    >
                </div>
            </div>
        </template>
        <!-- End of "Predogled oglasa" -->
    </figure>
</template>

<script>
export default {
    props: {
        step: {
            type: Number,
            default: 0,
        },
    },
};
</script>
